
// 以後用這個
const defaultParam = {
    "request_id": "",
    "pagination": {
        "dir": 1,
        "limit": 20,
        "page": 1,
        "sort": "created_date"
    },
    "filter_options": {
        "keyword": "",
        "rent_time": {
            "rent_type": 0,
            "begin_time": "",
            "end_time": ""
        },
        "geo_search": {
            "longitude": 0,
            "latitude": 0,
            "width": 0,
            "height": 0,
            "radius": 0
        },
        "equipment_ids": [],
        "service_ids": [],
        "city_ids": [],
        "category_ids": {}
    }
}
const getCitySearchParam = (id) => {
    return {
        ...defaultParam,
        filter_options: {
            ...defaultParam.filter_options,
            city_ids: [id]
        }
    };
}

const getUsageSearchParam = (usageId) => {
    return {
        ...defaultParam,
        filter_options: {
            ...defaultParam.filter_options,
            category_ids: {
                "3": [usageId]
            }
        }
    };
}

// Phase 1 SEO 組合頁:合併 城市 + 用途 + 人數帶 為單一搜尋條件
// 由既有 city / usage 搜尋參數的結果組合而成,缺哪一維就留空(不影響其餘篩選)。
const getComboSearchParam = (citySearchParam, usageSearchParam, capacityRange) => {
    return {
        ...defaultParam,
        filter_options: {
            ...defaultParam.filter_options,
            city_ids: citySearchParam?.filter_options?.city_ids ?? [],
            category_ids: usageSearchParam?.filter_options?.category_ids ?? {},
            people_cap_range: capacityRange ?? {}
        }
    };
}

const cityListUrl = {
    taipei: getCitySearchParam(1),
    newtaipei: getCitySearchParam(2),
    keelung: getCitySearchParam(7),
    taichung: getCitySearchParam(4),
    kaohsiung: getCitySearchParam(6),
    taoyuan: getCitySearchParam(3),
    tainan: getCitySearchParam(5),
    hsinchu: getCitySearchParam(8),
    miaoli: getCitySearchParam(10),
    changhua: getCitySearchParam(11),
    nantou: getCitySearchParam(12),
    yunlin: getCitySearchParam(13),
    chiayi: getCitySearchParam(14),
    pingtung: getCitySearchParam(16),
    yilan: getCitySearchParam(17),
    hualien: getCitySearchParam(18),
    taitung: getCitySearchParam(19),
    kinmen: getCitySearchParam(20),
    penghu: getCitySearchParam(21),
    lienchiang: getCitySearchParam(22),
};


export {getUsageSearchParam, cityListUrl, getComboSearchParam}
